// categoryIcons.tsx
import {
    Build as BuildIcon,
    CardGiftcard as CardGiftcardIcon,
    ChildFriendly as ChildFriendlyIcon,
    Construction as ConstructionIcon,
    DevicesOther as DevicesOtherIcon,
    DirectionsCar as DirectionsCarIcon,
    ElectricalServices as ElectricalServicesIcon,
    Pets as PetsIcon,
    SelfImprovement as SelfImprovementIcon,
    Snowboarding as SnowboardingIcon,
    SportsHandball as SportsHandballIcon
} from '@mui/icons-material';
import { Box, Paper, Typography } from '@mui/material';
import { man, women, religious, pApple } from '../../assests/icons';
import i18n from '../../services/localization/i18n';
import { Category } from '../../types';
// CategoryIcons.tsx


// 👇 no more dumb sparse arrays, use a proper record
 export const categoryIcons: Record<number, React.ReactNode> = {
    1: <DirectionsCarIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    30: <SelfImprovementIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    76773: <ChildFriendlyIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    76775: <Box component="img" src={man} width={30} height={35} alt="men fashion" />,
    76772: <Box component="img" src={women} width={30} height={35} alt="women fashion" />,
    76774: <Box component="img" src={religious} width={27} height={35} alt="religious" />,
    76776: <SnowboardingIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    1945: <ConstructionIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    5: <SportsHandballIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    74431: <PetsIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    76777: <BuildIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    6: <ElectricalServicesIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    76778: <DevicesOtherIcon fontSize="large" sx={{ color: '#15cdcb' }} />,
    76705: <Box component="img" src={pApple} width={24} height={35} alt="fruits" />,
    74405: <CardGiftcardIcon fontSize="large" sx={{ color: '#15cdcb' }} />
};






interface Props {
  data: Category[];
  getByCategoryId: (id: number, name: string) => void;
}

const CategoryIcons: React.FC<Props> = ({ data, getByCategoryId }) => {
  return (
    <Box>
      {data.map((item) => (
        <Paper
          key={item.categoryId}
          onClick={() => getByCategoryId(item.categoryId, item[`name_${i18n.language}` as keyof Category] as string)}
          sx={{ display: 'flex', alignItems: 'center', gap: 2, cursor: 'pointer', padding: 2 }}
        >
          {categoryIcons[item.categoryId]}
          <Typography>{item[`name_${i18n.language}` as keyof Category]}</Typography>
        </Paper>
      ))}
    </Box>
  );
};

export default CategoryIcons;
